'use strict';

var controlModelo = function () {
	var modeloNameCode = {
		name: null,
		code: null
	};

	var _getModeloNameCode = function _getModeloNameCode() {
		return modeloNameCode;
	};

	var _setModeloName = function _setModeloName(moi) {
		var modelo = void 0;
		var modelos = listaModelos.turismos;
		for (var i = 0; i < modelos.length; i++) {
			if (modelos[i].moi === moi) modelo = modelos[i];
		}
		modelos = listaModelos.comerciales;
		for (var i = 0; i < modelos.length; i++) {
			if (modelos[i].moi === moi) modelo = modelos[i];
		}

		modeloNameCode.name = modelo.nombre;
		modeloNameCode.code = modelo.modelcode;
		$('.js-nombre-modelo').html(modelo.nombre + ' <span class="code">(' + modelo.modelcode + ')</span>');
	};
	var _setEbrochure = function _setEbrochure(ebrochure) {
		if (ebrochure !== "") $('.js-ebrochure').attr('href', ebrochure).show();
	};
	var _setVideo = function _setVideo(video) {
		if (video !== '') {
			var videoURL = video.split('https://youtu.be/')[1];
			var videoHTML = '<iframe id="ytplayer" class="video" type="text/html" src="https://www.youtube.com/embed/' + videoURL + '?autoplay=1&rel=0&showinfo=0"frameborder="0" allowfullscreen>';

			$('.aop-top-banner').append('<span class="js-play play"></span>');

			$('.js-play').show().on('click', function () {
				$('#video').append(videoHTML);
				abreVideo();
			});
		}
	};

	var _listModelsPrev = function _listModelsPrev(data) {
		var modelos = modelsList.buildArray(listaModelos.turismos);
		var modelo = void 0;
		for (var i = 0; i < modelos.length; i++) {
			if (modelos[i].familia === data) modelo = modelos[i];
		}
		modelos = modelsList.buildArray(listaModelos.comerciales);
		for (var i = 0; i < modelos.length; i++) {
			if (modelos[i].familia === data) modelo = modelos[i];
		}
		$('.js-nombre-familia').text(data);
		if (typeof modelo.hijos !== 'undefined' && modelo.hijos.length > 1) {
			for (var _i = 0; _i < modelo.hijos.length; _i++) {
				var hijo = modelo.hijos[_i];
				var $domChildNode = $('<a/>');
				var nombre = hijo.nombre + ' <span class="code">(' + hijo.modelcode + ')</span>';
				$domChildNode.attr('href', hijo.link).html(nombre);
				// $domChildNode.attr('href', hijo.link).html(hijo.nombre + ' <span>('+hijo.modelcode+')</span>')
				$('.aop-cabecera-modelo .aop-versiones-anteriores').find('.versiones').append($domChildNode);
			}
		} else {
			$('.aop-cabecera-modelo .aop-versiones-anteriores').remove();
		}
	};

	return {
		setModeloName: _setModeloName,
		setEbrochure: _setEbrochure,
		setVideo: _setVideo,
		listModelsPrev: _listModelsPrev,
		getModeloNameCode: _getModeloNameCode
	};
}();